import { render, staticRenderFns } from "./terminal-details.vue?vue&type=template&id=72300daa&scoped=true"
import script from "./terminal-details.vue?vue&type=script&lang=js"
export * from "./terminal-details.vue?vue&type=script&lang=js"
import style0 from "./terminal-details.vue?vue&type=style&index=0&id=72300daa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72300daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72300daa')) {
      api.createRecord('72300daa', component.options)
    } else {
      api.reload('72300daa', component.options)
    }
    module.hot.accept("./terminal-details.vue?vue&type=template&id=72300daa&scoped=true", function () {
      api.rerender('72300daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/participant/terminal/form/terminal-details.vue"
export default component.exports